import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-5">
      <Container>
        <Row>
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="fw-bold mb-3">GUIRETTE SAS</h5>
            <p>
              Startup spécialisée dans la cartographie, l'analyse des sols et le suivi intelligent 
              des cultures grâce à l'intelligence artificielle.
            </p>
            <p>
              <strong>Slogan :</strong> Produire plus et mieux, sans gaspiller
            </p>
          </Col>
          
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="fw-bold mb-3">Liens utiles</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/" className="text-white text-decoration-none">Accueil</Link></li>
              <li className="mb-2"><Link to="/about" className="text-white text-decoration-none">À propos</Link></li>
              <li className="mb-2"><Link to="/contact" className="text-white text-decoration-none">Nous contacter</Link></li>
              <li className="mb-2"><Link to="/demo" className="text-white text-decoration-none">Demo offerte</Link></li>
              <li className="mb-2"><Link to="/devis-gratuit" className="text-white text-decoration-none">Devis gratuit</Link></li>
              <li className="mb-2"><Link to="/mentions-legales" className="text-white text-decoration-none">Mentions légales</Link></li>
              <li><Link to="/politique-de-confidentialite" className="text-white text-decoration-none">Politique de confidentialité</Link></li>
            </ul>
          </Col>
          
          <Col md={4}>
            <h5 className="fw-bold mb-3">Réseaux sociaux</h5>
            <div className="d-flex gap-3">
              <a href="https://www.facebook.com/share/16TEncfEqF/" className="text-white"><i className="bi bi-facebook fs-4"></i></a>
              <a href="#" className="text-white"><i className="bi bi-twitter fs-4"></i></a>
              <a href="https://www.linkedin.com/company/guirette/" className="text-white"><i className="bi bi-linkedin fs-4"></i></a>
      
            </div>
            
            <div className="mt-4">
              <h6 className="fw-bold mb-2">Newsletter</h6>
              <div className="d-flex">
                <input type="email" className="form-control rounded-0" placeholder="Votre email" />
                <button className="btn btn-success rounded-0">S'inscrire</button>
              </div>
            </div>
          </Col>
        </Row>
        
        <Row className="mt-4 pt-3 border-top">
          <Col className="text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} GUIRETTE SAS. Tous droits réservés.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;